import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import '../styles/LeftNav.css';
const navItems = [
    { id: 'welcome', label: 'Welcome', icon: '/assets/icon-sun.svg' },
    { id: 'pre-survey', label: 'Pre-Survey', icon: '/assets/icon-survey.svg' },
    { id: 'activities', label: 'Activities', icon: '/assets/icon-activities.svg' },
    { id: 'post-survey', label: 'Post-Survey', icon: '/assets/icon-post-survey.svg' },
];
const LeftNav = ({ activeItem, onItemClick, preSurveyComplete }) => {
    // Items that require pre-survey completion
    const lockedItems = ['activities', 'post-survey'];
    const isItemLocked = (itemId) => {
        return !preSurveyComplete && lockedItems.includes(itemId);
    };
    const handleItemClick = (itemId) => {
        if (!isItemLocked(itemId)) {
            onItemClick(itemId);
        }
    };
    return (_jsx("nav", { className: "left-nav", "aria-label": "Main navigation", children: _jsxs("div", { className: "nav-top", children: [_jsx("div", { className: "nav-logo", children: _jsx("img", { src: "/assets/i4e-logo-nav.svg", alt: "Intuit for Education" }) }), _jsx("ul", { className: "nav-items", role: "menubar", children: navItems.map((item) => {
                        const isActive = activeItem === item.id;
                        const isLocked = isItemLocked(item.id);
                        return (_jsx("li", { role: "none", children: _jsxs("button", { className: `nav-item ${isActive ? 'nav-item-active' : ''} ${isLocked ? 'nav-item-locked' : ''}`, onClick: () => handleItemClick(item.id), role: "menuitem", "aria-current": isActive ? 'page' : undefined, "aria-disabled": isLocked, title: isLocked ? 'Complete the Pre-Survey first' : undefined, children: [isActive && _jsx("div", { className: "nav-item-indicator", "aria-hidden": "true" }), _jsxs("div", { className: "nav-item-content", children: [_jsx("img", { src: item.icon, alt: "", className: "nav-item-icon", "aria-hidden": "true" }), _jsx("span", { className: "nav-item-label", children: item.label })] })] }) }, item.id));
                    }) })] }) }));
};
export default LeftNav;
